import styled from 'styled-components';
import { rem } from 'polished';

export const StyledDisqus = styled.div`
  .disqus__header {
    display: flex;
    margin-bottom: ${rem(`24px`)};
    pointer-events: none;
    justify-content: center;
    ${({ theme }) => theme.breakpoints.desktop`
      margin-bottom: ${rem(`36px`)};
    `}
  }
  .disqus_content {
    #disqus_thread button {
      color: blue;
      background: red;
    }
  }
`;
